<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <div class="vx-row mb-2">
        <div class="vx-col lg:w-5/12 w-full">
          <vs-input
            class="inputx"
            v-model="info.serial"
            name="serialName"
            :label="$t('SerialNumber')"
            @keyup.enter="addSerial()"
            :disabled="!AbilityAddSerial"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm mt-3"
            v-show="errors.has('serialName')"
            >{{ errors.first("serialName") }}</span
          >
        </div>
        <div class="vx-col lg:w-1/12 w-full mt-6">
          <vs-button
            size="small"
            radius
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-plus"
            @click.prevent="addSerial()"
            class="mb-2 mt-2 lfloat"
            :disabled="!AbilityAddSerial"
          ></vs-button>
        </div>
        <div class="vx-col lg:w-5/12 w-full pt-8" v-if="AbilityAddSerial">
          <span class="errorMessage" v-if="isSerialRepeatability"
            >سریال تکراری</span
          >
          <span class="errorMessage" v-if="!isSerialAuthorization"
            >سریال غیرمجاز</span
          >
          <span class="errorMessage" v-if="!isItemHaveRemaining">
            سریال اشتباه</span
          >
        </div>
      </div>

      <vs-table :data="modelForShowInPage" class="custom-tbl">
        <template slot="thead">
          <th>#</th>
          <th>{{ $t("ItemCode") }}</th>
          <th>{{ $t("CountOfOperatorRequested") }}</th>
          <th>{{ $t("CountOfRegistered") }}</th>
          <th>{{ $t("RemainingCountForCheckout") }}</th>
          <th>{{ $t("Action") }}</th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :key="i"
            v-for="(tr, i) in data"
            :class="
              tr.remainingCountForCheckout == tr.serialsInfo.length ||
              tr.remainingCountForCheckout == 0
                ? 'bg-success'
                : ''
            "
          >
            <vs-td style="width: 5%">
              {{ i + 1 }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.itemCode }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.remainingCountForCheckout }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ tr.serialsInfo.length }}
            </vs-td>
            <vs-td style="width: 20%">
              {{
                tr.serialsInfo.length
                  ? tr.remainingCountForCheckout - tr.serialsInfo.length
                  : tr.remainingCountForCheckout
              }}
            </vs-td>
            <vs-td style="width: 15%">
              <!-- <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteAllSerialForRow(i)"
                class="d-inline"
              ></vs-button> -->
            </vs-td>
          </vs-tr>
          <!-- <vs-tr>
            <vs-td style="width: 5%" class="bg-danger">
              {{ modelForShowInPage.length + 1 }}
            </vs-td>
            <vs-td style="width: 20%">
              {{ $t("WrongBarcode") }}
            </vs-td>
            <vs-td style="width: 20%">
              ---
            </vs-td>
            <vs-td style="width: 20%">
              {{ countWrongBarcode }}
            </vs-td>
            <vs-td style="width: 20%">
              ---
            </vs-td>
            <vs-td style="width: 15%">
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteSerial(i)"
                class="d-inline"
              ></vs-button>
            </vs-td>
          </vs-tr> -->
        </template>
      </vs-table>
      <show-serials-error
        :wrong-list="wrongSerials"
        :extera-list="extraSerials"
        :duplicate-list="duplicateSerials"
        :allValidSerials="listOfSerialsSeparationWithItemCode"
      >
      </show-serials-error>
      <vs-button
        type="filled"
        class="float-right mb-4 mt-4"
        :disabled="wrongSerials.length > 0 || extraSerials.length > 0"
        @click.prevent="submitSerialForm"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>
<style lang="css">
.errorMessage {
  color: red;
  opacity: 1;
}
.con-vs-popup .vs-popup {
  width: 1000px !important;
}

.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>
<script>
import { mapActions } from "vuex";
import ShowSerialsError from "./ShowSerialsError.vue";

export default {
  name: "warehouseManagement_CheckOutTransactions_SerialPopup",
  components: {
    ShowSerialsError,
  },
  props: {
    show: { default: false },
    dischargePermissionId: "",
    basketId: "",
    storeId: "",
  },
  data() {
    return {
      countWrongBarcode: 0,
      lastIndexRegistered: 0,
      model: {},
      listOfSerialsSeparationWithItemCode: [],
      modelForShowInPage: [],
      newSerialsInfo: [],
      AbilityAddSerial: true,
      isSerialRepeatability: false,
      isSerialAuthorization: true,
      isItemHaveRemaining: true,
      isAddNewSerial: false,
      info: {
        serial: "",
      },
      itemCodeCurrentInApiList: "",
      wrongSerials: [],
      duplicateSerials: [],
      extraSerials: [],
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish", "", "notNew");
        this.info.serial = "";
        this.$validator.reset();
      },
    },
  },
  methods: {
    ...mapActions({
      GetAllSeriesRelatedToCurrentDischrgePermission:
        "draftOrder/GetAllSeriesRelatedToCurrentDischrgePermission",
    }),
    serialExistingInInventory() {
      for (
        let index = 0;
        index < this.listOfSerialsSeparationWithItemCode.length;
        index++
      ) {
        if (
          this.listOfSerialsSeparationWithItemCode[index].serials.includes(
            this.info.serial
          )
        ) {
          this.itemCodeCurrentInApiList =
            this.listOfSerialsSeparationWithItemCode[index].itemCode;
          return true;
        }
      }
      this.isSerialAuthorization = false;
      return false;
    },
    itemHaveRemaining(data) {
      if (data.remainingCountForCheckout > data.serialsInfo.length) {
        return true;
      } else {
        return false;
        // for (let index = 0; index < this.modelForShowInPage.length; index++) {
        //   if (!this.serialIsDuplicate(this.modelForShowInPage[index])) {
        //     this.$swal({
        //     position: "center-center",
        //     type: "error",
        //     text: `سریال ${this.info.serial} خارج از ظرفیت اضافه شده است.`,
        //     showConfirmButton: false,
        //   });
        //     this.isItemHaveRemaining = false;
        //     if(!this.exteraListDuplicate(this.info.serial)){
        //       this.extraSerials.push({
        //       itemCode: "",
        //       serial: this.info.serial,
        //     });
        //     }
        //     return false;
        //   }
        //   else{
        //     return false;
        //   }
        // }
      }
    },
    exteraSerialExistInDuplicateList(serial) {
      if(this.extraSerials.length>0){
        let x= this.extraSerials.find(x=>x.serial===this.info.serial)
      if(x !==undefined){
        return true
      }
      else{
        return false
      }

      }
      else{
        false
      }
    },
    serialIsDuplicate(data) {
      for (let index = 0; index < data.serialsInfo.length; index++) {
        if (data.serialsInfo[index].serial == this.info.serial) {
          this.isSerialRepeatability = true;
          this.duplicateSerials.push({
            itemCode: "",
            serial: this.info.serial,
          });
          return true;
        }
      }
      return false;
    },
    setAbilityAddSerial() {
      for (let index = 0; index < this.modelForShowInPage.length; index++) {
        if (
          this.modelForShowInPage[index].remainingCountForCheckout ==
            this.modelForShowInPage[index].serialsInfo.length ||
          this.modelForShowInPage[index].remainingCountForCheckout == 0
        ) {
          this.AbilityAddSerial = false;
        } else {
          this.AbilityAddSerial = true;
          break;
        }
      }
    },
    counterWrongBarcode() {
      if (!this.isAddNewSerial) {
        this.countWrongBarcode += 1;
      }
    },
    resetForm() {
      this.isAddNewSerial = false;
      this.info.serial = "";
      setTimeout(() => {
        this.isSerialRepeatability = false;
        this.isSerialAuthorization = true;
        this.isItemHaveRemaining = true;
      }, 500);
    },
    findLastIndex() {
      this.lastIndexRegistered = 0;
      for (let index = 0; index < this.modelForShowInPage.length; index++) {
        if (this.modelForShowInPage[index].serialsInfo.length) {
          for (
            let i = 0;
            i < this.modelForShowInPage[index].serialsInfo.length;
            i++
          ) {
            if (
              this.lastIndexRegistered <
              this.modelForShowInPage[index].serialsInfo[i].index
            ) {
              this.lastIndexRegistered =
                this.modelForShowInPage[index].serialsInfo[i].index;
            }
          }
        }
      }
    },
    addSerial() {
      if (this.info.serial) {
        if (this.serialExistingInInventory()) {
          for (let index = 0; index < this.modelForShowInPage.length; index++) {
            if (
              this.modelForShowInPage[index].itemCode ==
              this.itemCodeCurrentInApiList
            ) {
              if (
                this.itemHaveRemaining(this.modelForShowInPage[index]) &&
                !this.serialIsDuplicate(this.modelForShowInPage[index])
              ) {
                this.findLastIndex();
                this.lastIndexRegistered += 1;
                var newSerial = {
                  serial: this.info.serial,
                  index: this.lastIndexRegistered,
                };
                this.modelForShowInPage[index].serialsInfo.push(newSerial);
                this.newSerialsInfo.push(newSerial);
                newSerial = {};
                this.isAddNewSerial = true;
                this.setAbilityAddSerial();
                break;
              } else if (
                !this.itemHaveRemaining(this.modelForShowInPage[index]) &&
                this.serialIsDuplicate(this.modelForShowInPage[index])
              ) {
              } else if (
                !this.itemHaveRemaining(this.modelForShowInPage[index]) &&
                !this.serialIsDuplicate(this.modelForShowInPage[index])
              ) {
                this.$swal({
                  position: "center-center",
                  type: "error",
                  text: `سریال ${this.info.serial} خارج از ظرفیت اضافه شده است.`,
                  showConfirmButton: false,
                });
                this.isItemHaveRemaining = false;
                if (!this.exteraSerialExistInDuplicateList(this.info.serial)) {
                  this.extraSerials.push({
                    itemCode: "",
                    serial: this.info.serial,
                  });
                }
              }
              break;
            }
          }
        } else {
          this.$swal({
            position: "center-center",
            type: "error",
            text: `سریال ${this.info.serial} اشتباه اضافه شده است.`,
            showConfirmButton: false,
          });
          this.wrongSerials.push({
            itemCode: "",
            serial: this.info.serial,
          });
        }
      }
      this.counterWrongBarcode();
      this.resetForm();
    },
    // deleteAllSerialForRow(index) {
    //   this.$swal({
    //     title: "آیا از حذف تمام سریال های این ردیف اطمینان دارید؟",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "بلی",
    //     cancelButtonText: "خیر"
    //   }).then(result => {
    //     if (result.value) {
    //       this.removeAllSerialFromSelectedTransaction(index);
    //       this.modelForShowInPage[index].countOfRegistered = 0;
    //     }
    //   });
    // },
    // deleteSerial(index) {
    //   this.$swal({
    //     title: "آیا از حذف این رکورد اطمینان دارید؟",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "بلی",
    //     cancelButtonText: "خیر"
    //   }).then(result => {
    //     if (result.value) {
    //       this.selectedTransactionSerials.splice(index, 1);
    //       if (this.totalCountCurrent != this.selectedTransactionSerials.length)
    //         this.AbilityAddSerial = true;
    //       this.$swal({
    //         position: "center-center",
    //         type: "success",
    //         text: "رکورد مورد‌نظر با موفقیت حذف شد!",
    //         showConfirmButton: false,
    //         timer: 2000
    //       });
    //     }
    //   });
    // },
    submitSerialForm() {
      this.$emit("finish", this.modelForShowInPage, "fromBarcode");
    },
    async getAllSerialsAvailable() {
      this.listOfSerialsSeparationWithItemCode = [];
      this.model = {
        storeId: "4",
        shelveId: "1",
        dischargePermissionId: this.dischargePermissionId,
      };
      this.GetAllSeriesRelatedToCurrentDischrgePermission(this.model).then(
        (r) => {
          this.listOfSerialsSeparationWithItemCode = r;
        }
      );
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.modelForLocalStorage = localStorage.getItem(
          "basket" + this.basketId + "store" + this.storeId
        );
        this.newSerialsInfo = [];
        this.modelForShowInPage = JSON.parse(this.modelForLocalStorage);
        this.getAllSerialsAvailable();
      }
    },
  },
};
</script>
